export const Env = {
  name: process.env.NEXT_PUBLIC_VERCEL_ENV || 'development'
}
